import React from 'react';
import { XIcon } from 'lucide-react';
import { LoyaltyPointsSection } from './LoyaltyPointsSection';
interface LoyaltyPointsBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}
export function LoyaltyPointsBottomSheet({
  isOpen,
  onClose
}: LoyaltyPointsBottomSheetProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-end" data-id="element-658" data-mp="2yjsyv3jrd5gz">
      <div className="bg-white rounded-t-xl w-full max-h-[90vh] overflow-y-auto" data-id="element-659" data-mp="21vn0gydfj9b5">
        <div className="sticky top-0 bg-white border-b border-gray-200 flex items-center justify-between p-4 z-10" data-id="element-660" data-mp="25w6tpquvtss0">
          <h2 className="text-lg font-bold" data-id="element-661" data-mp="2ava13hyc4b35">Rabeh Rewards</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-662" data-mp="2axw89ghbcoku">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-663" data-mp="3maymw5zur42d" />
          </button>
        </div>
        <div className="p-4" data-id="element-664" data-mp="3r9t4j4m32mkw">
          <LoyaltyPointsSection data-id="element-665" data-mp="3r907wwgu9dgh" />
        </div>
      </div>
    </div>;
}